export default __webpack_public_path__ + "static/media/img-ln-4-products.57ef7460.png";